import { t } from 'i18next';
import { CheckCircleFill } from '@peacecover/icon';
import { usePaymentSuccess } from './hooks/usePaymentSuccess';
import GradientLoadingSpinner from '../components/GradientLoadingSpinner';

const PaymentSuccessPage = () => {
  const { isLoading } = usePaymentSuccess();

  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center">
        <GradientLoadingSpinner size={36} />
      </div>
    );
  }

  return (
    <div className="h-screen flex flex-col items-center justify-center gap-[17px]">
      <CheckCircleFill size={82} backgroundColor="#3CC974" strokeColor="#FFFFFF" />
      <p className="text-[24px] font-semibold text-text-main-lv2 leading-[29px]">
        {t('Payment.success')}
      </p>
    </div>
  );
};

export default PaymentSuccessPage;
